import { location_historyService } from '../_services';

const state = { onRequest: false, location_history: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        location_historyService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  location_history: state => {
    return state.location_history
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.location_history = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.location_history = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.location_history = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const location_histories = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
